<template>
    <div>
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <div class="alert alert-info" v-if="dateNotice">
            <p><strong>Heads Up!</strong> <span v-text="dateNotice"></span></p>
        </div>
        <form role="form" @submit.prevent="queueImport">
            <div class="form-group">
                <label for="account">Client</label>
                <select class="form-control" name="account" v-model="form.client">
                    <option value="">Choose Client</option>
                    <option :value="client.name" v-for="client in clients" :key="client.id">{{ client.name }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="account">Vendor</label>
                <select class="form-control" name="account" v-model="form.vendor">
                    <option value="">Choose a Vendor</option>
                    <option value="AdWords">AdWords</option>
                    <option value="Bing Ads">Bing Ads</option>
                    <option value="Facebook">Facebook</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Quora">Quora</option>
                    <option value="Twitter">Twitter</option>
                    <option value="Yahoo!">Yahoo!</option>
                </select>
            </div>
            <div class="form-group">
                <label for="range">Date Range</label>
                <select class="form-control" name="range" v-model="form.dateRange">
                    <option value="Yesterday">Yesterday</option>
                    <option value="LastSevenDays">Last 7 Days</option>
                    <option value="ThisMonth">This Month</option>
                    <option value="LastMonth">Last Month</option>
                    <option value="ThisYear">This Year</option>
                    <option value="Custom">Custom</option>
                </select>
            </div>
            <div class="form-group daterange" v-show="form.dateRange == 'Custom'">
                <datepicker v-model="range.start" format="yyyy-MM-dd" icons-font="fa" placeholder="Start"></datepicker>
                <datepicker v-model="range.end" format="yyyy-MM-dd" icons-font="fa" placeholder="End"></datepicker>
            </div>
            <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading || unsubmittable">Import</button>
        </form>
    </div>
</template>

<script>
    import { datepicker } from 'vue-strap';

    export default {
        components: { datepicker },

        data() {
            return {
                clients: [],
                form: {
                    client: '',
                    vendor: '',
                    dateRange: 'Yesterday',
                    errors: [],
                },
                range: {
                    start: '',
                    end: '',
                },
                loading: false
            };
        },

        created() {
            this.getClentList();
        },

        computed: {
            unsubmittable() {
                return this.form.client === '' || this.form.vendor === '';
            },
            dateNotice() {
                switch (this.form.vendor) {
                    case 'LinkedIn':
                        return 'The max date range per import is 6 months.'
                    case 'Twitter':
                        return 'The max date range per import is 7 days.'
                    case 'Quora':
                        return 'The max date range per import is 30 days.'
                    default:
                        return false;
                }
            },
            formErrors() {
                return Object.keys(this.form.errors).length > 0;
            }
        },

        methods: {
            getClentList() {
                axios.get('/api/clients')
                    .then(({data}) => {
                        this.clients = data;
                    });
            },

            queueImport() {
                this.loading = true;
                let request = this.buildRequest();
                console.log(request);
                axios.post('/api/imports/queue/client/add', request)
                    .then(({data}) => {
                        Bus.$emit('show-success-alert', data.message);
                        this.loading = false;
                        this.reset();
                    })
                    .catch(error => {
                        this.form.errors = error.response.data.errors;
                        this.loading = false;
                    });
            },

            buildRequest() {
                let range = this.form.dateRange !== 'Custom' ? this.form.dateRange : JSON.stringify(this.range);
                return {
                    client: this.form.client,
                    vendor: this.form.vendor,
                    dateRange: range
                };
            },

            reset() {
                this.form = {
                    client: '',
                    vendor: '',
                    dateRange: 'Yesterday',
                    errors: [],
                };
            }
        }
    }
</script>

<style scoped lang="scss">
    .daterange {
        div {
            width: 49%;

            &:not(:first-child) {
				float: right;
			}
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/imports/ClientImportForm.vue